import React from "react";
import { ActivityType } from "../../../domain/ActivityType";
import { ScopeApplication } from "../../../domain/ScopeApplication";
import { Activity } from "@ofqual/portal-activity-feed";
import { ActionType } from "./ExpansionActivityFeedTypes";
import { NoteDialog } from "./dialogs/NoteDialog";
import { DocumentDialog } from "./dialogs/DocumentDialog";
import { UpdatedScopeDialog } from "./dialogs/UpdatedScopeDialog";
import { DateDialog } from "./dialogs/DateDialog";
import { AdditionalEvidenceDialog } from "./dialogs/AdditionalEvidenceDialog";
import { AdditionalEvidenceRequest } from "../../../domain/AdditionalEvidenceRequest";
import { MessageDialog } from "./dialogs/MessageDialog";
import { EvidenceDialog } from "./dialogs/additionalEvidence/EvidenceDialog";

export const renderDialog = (
  application: ScopeApplication | null,
  evidenceRequests: AdditionalEvidenceRequest[] | null,
  focussedEntity: ActionType | Activity | null,
  onClose: () => void
) => {
  if (!focussedEntity) {
    return;
  }

  const activity = focussedEntity as Activity;
  const actionType = focussedEntity as ActionType;

  if (activity && activity.activityType) {
    switch (activity.activityType) {
      case ActivityType.ScopeChanged:
        return <UpdatedScopeDialog activity={activity} onClose={onClose} />;
      case ActivityType.ScopeAdditionalEvidenceRequest:
        return <EvidenceDialog activity={activity} onClose={onClose} />;
      case ActivityType.ScopeAdditionalEvidenceSubmitted:
        return <EvidenceDialog activity={activity} onClose={onClose} />;
      default:
        return null;
    }
  } else {
    switch (actionType) {
      case ActionType.Note:
        return <NoteDialog application={application!} onClose={onClose} />;
      case ActionType.Document:
        return <DocumentDialog application={application!} onClose={onClose} />;
      case ActionType.Date:
        return <DateDialog application={application!} onClose={onClose} />;
      case ActionType.AdditionalEvidence:
        return (
          <AdditionalEvidenceDialog
            application={application!}
            onClose={onClose}
            existingEvidenceRequests={evidenceRequests!}
          />
        );
      case ActionType.SendMessage:
        return <MessageDialog application={application!} onClose={onClose} />;
    }
  }
};
